import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Header from './header';
import SideMenu from './side-menu';
import Tabs from './tabs';
import Footer from '../../../shared/footer/components/footer';
import CookiesWrapper from '../../../../common/cookies-wrapper';
import constants from '../../../../common/constants';
import registerConstants from '../../register/constants/register-constants';
import { toggleMenu, handleBlockUnblockUi } from '../actions/layout-actions';

import '../styles/layout.css';

class Layout extends Component {
  componentDidMount() {
    const { uiBlocked, handleBlockUnblockUi } = this.props;
    const sessionTokens = CookiesWrapper.getCookie(constants.cookie_key_word);

    if (sessionTokens && sessionTokens.user_type && sessionTokens.user_bo_status) {
      if (
        (sessionTokens.user_type === registerConstants.user_types.ifs_type ||
          sessionTokens.user_type === registerConstants.user_types.ib ||
          sessionTokens.user_type === registerConstants.user_types.affiliate) &&
        sessionTokens.user_bo_status !== constants.bo_statuses.approved
      ) {
        handleBlockUnblockUi(true);
      }
    }

    if (uiBlocked && sessionTokens && sessionTokens.user_bo_status === constants.bo_statuses.approved) {
      handleBlockUnblockUi(false);
    }
  }

  hideMenu() {
    const { showMenu, toggleMenu } = this.props;

    if (showMenu) {
      toggleMenu(false);
    }
  }

  shouldHideRiskDisclaimer = () => {
    const { location } = this.props;
    const hideRiskDisclaimerRoutes = ['/app/dashboard'];

    return hideRiskDisclaimerRoutes.indexOf(location.pathname) > -1;
  };

  render() {
    const { children, location } = this.props;

    return (
      <div className="layout-container" onClick={() => this.hideMenu()}>
        <Header />
        <div className="row layout-container__wrapper">
          <div className="col-md-9 col-sm-9 col-xs-12 layout-container__wrapper__main">
            <Tabs location={location} />
            <div className="app-content">{children}</div>
          </div>
          <div className="col-md-3 col-sm-3 col-xs-12 position-static-important">
            <SideMenu location={location} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Footer hideRiskDisclaimer={this.shouldHideRiskDisclaimer()} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showMenu: state.layoutReducer.showMenu,
  uiBlocked: state.layoutReducer.uiBlocked,
});

const mapDispatchToProps = dispatch => ({
  toggleMenu: show => {
    dispatch(toggleMenu(show));
  },
  handleBlockUnblockUi: uiBlocked => {
    dispatch(handleBlockUnblockUi(uiBlocked));
  },
});

Layout.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);



// WEBPACK FOOTER //
// ./src/app/main/layout/components/layout.js